<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    ref="container"
    :style="getContainerStyle"
  >
    <div
      ref="left"
      :style="getLeftStyle"
    >
      <slot name="left" />
    </div>
    <div
      ref="center"
      :style="getCenterStyle"
    >
      <slot name="center" />
    </div>
    <div
      ref="right"
      :style="getRightStyle"
    >
      <slot name="right" />
    </div>
  </div>
</template>

<script>
  import { Layout } from '@js/styles'
  import { mapState } from 'vuex'

  export default {
    name: 'FlexLayoutPrimary',
    inheritAttrs: false,
    props: {
      showFooter: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        wrapped: null,
      };
    },
    mounted: function () {
      this.checkFlexWrap();
    },
    computed: {
      ...mapState({
        windowWidth: state => state.window.width,
      }),
      getCenterStyle: function () {
        return {
          flex: 1,
          height: this.height,
          maxHeight: this.maxHeight,
          minHeight: this.minHeight,
          minWidth: '220px',
          padding: `${Layout.space.sm} ${Layout.space.md}`,
        };
      },
      getContainerStyle: function () {
        return {
          alignItems: 'stretch',
          display: 'flex',
          flex: 1,
          flexWrap: 'wrap',
          height: '100%',
          padding: `0 ${Layout.space.sm}`,
          width: '100%',
        };
      },
      getLeftStyle: function () {
        return {
          flex: 1,
          height: this.height,
          maxHeight: this.maxHeight,
          minHeight: this.minHeight,
          minWidth: '220px',
          padding: `${Layout.space.sm} ${Layout.space.md}`,
        };
      },
      getRightStyle: function () {
        return {
          display: this.wrapped ? 'block' : 'flex',
          flex: 2,
          height: this.height,
          minHeight: this.minHeight,
          padding: `${Layout.space.sm} ${Layout.space.md}`,
        };
      },
      height: function () {
        const offset = this.showFooter ? '276px' : '342px';
        return this.wrapped ? null : `calc(100vh - ${offset})`; // or - 342px
      },
      maxHeight: function () {
        return this.wrapped ? '480px' : null;
      },
      minHeight: function () {
        return this.wrapped
          ? null
          : this.showFooter ? '372px' : '280px';
      },
    },
    methods: {
      checkFlexWrap: function () {
        const containerWidth = this.$refs?.container?.offsetWidth;
        const rightWidth = this.$refs?.right?.offsetWidth;
        this.wrapped = containerWidth - rightWidth - 16 === 0;
      },
    },
    watch: {
      windowWidth: function (newVal, oldVal) {
        this.checkFlexWrap();
      },
      wrapped: function (newVal, oldVal) {
        this.$emit(newVal ? 'wrapped' : 'unwrapped');
      },
    },
  };
</script>
